export default {
    // Header Section
    "discover_your": "ನಿಮ್ಮ",
    "nature_report": "ಸ್ವಭಾವ ವಿಶ್ಲೇಷಣೆ",
    "natural_personality_insights": "ನೈಸರ್ಗಿಕ ವ್ಯಕ್ತಿತ್ವ ಒಳನೋಟಗಳು",
    "nature_report_description": "ಸಮಗ್ರ ವಿಶ್ಲೇಷಣೆಯ ಮೂಲಕ ನಿಮ್ಮ ನಿಜವಾದ ವ್ಯಕ್ತಿತ್ವ ಮತ್ತು ಸಹಜ ಸ್ವಭಾವವನ್ನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಿ. ನಿಮ್ಮ ಜನ್ಮ ವಿವರಗಳ ಆಧಾರದ ಮೇಲೆ ನಿಮ್ಮ ನೈಸರ್ಗಿಕ ನಡವಳಿಕೆಯ ರೂಪಗಳು, ಅಂತರ್ಗತ ಶಕ್ತಿಗಳು, ಮೂಲ ಸ್ವಭಾವ ಮತ್ತು ಅಧಿಕೃತ ಸ್ವಯಂ ಅಭಿವ್ಯಕ್ತಿ ಶೈಲಿಯನ್ನು ಕಂಡುಹಿಡಿಯಿರಿ.",

    // Service Information
    "enter_details_for_nature_analysis": "ಸ್ವಭಾವ ವಿಶ್ಲೇಷಣೆಗಾಗಿ ನಿಮ್ಮ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ",
    "complete_nature_analysis": "ಸಂಪೂರ್ಣ ಸ್ವಭಾವ ವಿಶ್ಲೇಷಣೆ",
    "service_price": "ಸೇವೆಯ ಬೆಲೆ",
    "comprehensive_nature_analysis_note": "ನಿಮ್ಮ ನೈಸರ್ಗಿಕ ವ್ಯಕ್ತಿತ್ವ ಮತ್ತು ನಡವಳಿಕೆಯ ರೂಪಗಳ ಆಳವಾದ ವಿಶ್ಲೇಷಣೆ",

    // Form Fields
    "full_name": "ಪೂರ್ಣ ಹೆಸರು",
    "enter_full_name": "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
    "name_natural_vibration": "ನಿಮ್ಮ ಹೆಸರು ನಿಮ್ಮ ನೈಸರ್ಗಿಕ ವ್ಯಕ್ತಿತ್ವ ಕಂಪನಗಳೊಂದಿಗೆ ಪ್ರತಿಧ್ವನಿಸುತ್ತದೆ",
    "email_address": "ಇಮೇಲ್ ವಿಳಾಸ",
    "enter_email_address": "ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
    "phone_number": "ದೂರವಾಣಿ ಸಂಖ್ಯೆ",
    "enter_phone_number": "ನಿಮ್ಮ ದೂರವಾಣಿ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    "gender": "ಲಿಂಗ",
    "male": "ಪುರುಷ",
    "female": "ಮಹಿಳೆ",
    "other": "ಇತರೆ",
    "date_of_birth": "ಜನ್ಮ ದಿನಾಂಕ",
    "birth_date_personality_nature": "ನಿಮ್ಮ ನೈಸರ್ಗಿಕ ವ್ಯಕ್ತಿತ್ವ ಲಕ್ಷಣಗಳು ಮತ್ತು ಮೂಲಭೂತ ಸ್ವಭಾವವನ್ನು ನಿರ್ಧರಿಸಲು ಅಗತ್ಯವಾದುದು",
    "preferred_language": "ಆದ್ಯತೆಯ ಭಾಷೆ",
    "english": "ಇಂಗ್ಲಿಷ್",
    "hindi": "ಹಿಂದಿ",
    "telugu": "ತೆಲುಗು",
    "kannada": "ಕನ್ನಡ",
    "language_note": "ನಿಮ್ಮ ಸ್ವಭಾವ ವಿಶ್ಲೇಷಣೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿದ ಭಾಷೆಯಲ್ಲಿ ತಲುಪಿಸಲಾಗುವುದು",

    // Core Nature Features
    "personality_traits_analysis": "ವ್ಯಕ್ತಿತ್ವ ಲಕ್ಷಣಗಳ ವಿಶ್ಲೇಷಣೆ",
    "behavioral_patterns_insights": "ನಡವಳಿಕೆಯ ರೂಪಗಳ ಒಳನೋಟಗಳು",
    "strengths_weaknesses_profile": "ಶಕ್ತಿಗಳು ಮತ್ತು ದೌರ್ಬಲ್ಯಗಳ ಪ್ರೊಫೈಲ್",
    "natural_talents_discovery": "ನೈಸರ್ಗಿಕ ಪ್ರತಿಭೆಗಳ ಆವಿಷ್ಕಾರ",
    "life_approach_guidance": "ಜೀವನ ವಿಧಾನ ಮಾರ್ಗದರ್ಶನ",
    "pdf_download": "ಸಮಗ್ರ PDF ವರದಿ",
    "what_you_get": "ನಿಮ್ಮ ಸ್ವಭಾವ ವಿಶ್ಲೇಷಣೆಯು ಏನನ್ನು ಒಳಗೊಂಡಿದೆ",
    "comprehensive_personality_profile": "ಸಮಗ್ರ ವ್ಯಕ್ತಿತ್ವ ಪ್ರೊಫೈಲ್",
    "natural_behavior_patterns": "ನೈಸರ್ಗಿಕ ನಡವಳಿಕೆಯ ರೂಪಗಳು",
    "innate_talents_abilities": "ಸಹಜ ಪ್ರತಿಭೆಗಳು ಮತ್ತು ಸಾಮರ್ಥ್ಯಗಳು",
    "personal_growth_guidance": "ವೈಯಕ್ತಿಕ ಬೆಳವಣಿಗೆಯ ಮಾರ್ಗದರ್ಶನ",

    // Actions & Buttons
    "pay_and_generate_analysis": "ನನ್ನ ಸ್ವಭಾವ ವಿಶ್ಲೇಷಣೆಯನ್ನು ಪಡೆಯಿರಿ",
    "processing_payment": "ಪಾವತಿಯನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತಿದೆ",
    "processing_request": "ವಿಶ್ಲೇಷಣೆಯನ್ನು ರಚಿಸಲಾಗುತ್ತಿದೆ",

    // Payment & Success Messages
    "thank_you": "ಧನ್ಯವಾದಗಳು",
    "payment_successful": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಿದೆ!",
    "nature_analysis_processing": "ನಿಮ್ಮ ಸ್ವಭಾವ ವಿಶ್ಲೇಷಣೆಯನ್ನು ನಮ್ಮ ತಜ್ಞ ವ್ಯಕ್ತಿತ್ವ ವಿಶ್ಲೇಷಕರು ತಯಾರಿಸುತ್ತಿದ್ದಾರೆ. ನಿಮ್ಮ ನೈಸರ್ಗಿಕ ವ್ಯಕ್ತಿತ್ವ ಮತ್ತು ನಡವಳಿಕೆಯ ರೂಪಗಳ ಬಗ್ಗೆ ವಿಸ್ತೃತ ಒಳನೋಟಗಳನ್ನು ನೀವು ಪಡೆಯುವಿರಿ.",
    "order_id": "ಆರ್ಡರ್ ID",
    "payment_id": "ಪಾವತಿ ID",
    "amount_paid": "ಪಾವತಿಸಿದ ಮೊತ್ತ",

    // Delivery Information
    "delivery_information": "ವಿತರಣಾ ಮಾಹಿತಿ",
    "delivery_time": "ವಿಶ್ಲೇಷಣೆ ವಿತರಣೆ",
    "within_8_hours_delivery_note": "ನಿಮ್ಮ ವಿಸ್ತೃತ ಸ್ವಭಾವ ವರದಿ 8 ಗಂಟೆಗಳೊಳಗೆ ಸಿದ್ಧವಾಗುತ್ತದೆ",
    "whatsapp_notification": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳು",
    "whatsapp_delivery_note": "WhatsApp ನಲ್ಲಿ ತತ್ಕ್ಷಣ ಸೂಚನೆಗಳನ್ನು ಸ್ವೀಕರಿಸಿ",
    "email_delivery": "ಇಮೇಲ್ ವಿತರಣೆ",
    "email_delivery_note": "ಸಂಪೂರ್ಣ ವಿಶ್ಲೇಷಣೆಯನ್ನು ತಲುಪಿಸಲಾಗಿದೆ",

    // What You'll Receive
    "what_youll_receive": "ನಿಮ್ಮ ಸ್ವಭಾವ ವಿಶ್ಲೇಷಣೆ ಪ್ಯಾಕೇಜ್",
    "detailed_nature_report": "ಸಮಗ್ರ ಸ್ವಭಾವ ವರದಿ (PDF)",
    "personality_traits_breakdown": "ವ್ಯಕ್ತಿತ್ವ ಲಕ್ಷಣಗಳ ವಿಭಜನೆ",
    "behavioral_insights_guide": "ನಡವಳಿಕೆಯ ಒಳನೋಟಗಳ ಮಾರ್ಗದರ್ಶಿ",
    "natural_abilities_assessment": "ನೈಸರ್ಗಿಕ ಸಾಮರ್ಥ್ಯಗಳ ಮೌಲ್ಯಮಾಪನ",
    "personal_development_roadmap": "ವೈಯಕ್ತಿಕ ಅಭಿವೃದ್ಧಿ ಮಾರ್ಗಸೂಚಿ",

    // Visual Content
    "sample_nature_analysis": "ಮಾದರಿ ಸ್ವಭಾವ ವಿಶ್ಲೇಷಣೆ",
    "dominant_nature_type": "ಪ್ರಧಾನ ಸ್ವಭಾವ ಪ್ರಕಾರ",
    "sample_nature_reading": "ಬಲವಾದ ನಾಯಕತ್ವ ಗುಣಗಳೊಂದಿಗೆ ಸಮತೋಲಿತ ಭೂಮಿ-ಅಗ್ನಿ ಸ್ವಭಾವ",
    "sample_nature_preview": "ಮೂಲಭೂತ ಒಳನೋಟಗಳೊಂದಿಗೆ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಸ್ವಭಾವ ವಿಶ್ಲೇಷಣೆಯ ಪೂರ್ವವೀಕ್ಷಣೆ",
    "nature_elements": "ಸ್ವಭಾವ ಮೂಲಧಾತುಗಳು",

    // Nature Element Types
    "fire": "ಅಗ್ನಿ",
    "water": "ನೀರು",
    "earth": "ಭೂಮಿ",
    "air": "ವಾಯು",
    "ether": "ಆಕಾಶ",
    "nature": "ಸ್ವಭಾವ",

    // Status & Processing
    "your_nature_analysis_status": "ನಿಮ್ಮ ಸ್ವಭಾವ ವಿಶ್ಲೇಷಣೆಯ ಸ್ಥಿತಿ",
    "processing_your_analysis": "ನಿಮ್ಮ ನೈಸರ್ಗಿಕ ವ್ಯಕ್ತಿತ್ವವನ್ನು ವಿಶ್ಲೇಷಿಸಲಾಗುತ್ತಿದೆ",
    "analysis_processing_message": "ನಿಮ್ಮ ಅಧಿಕೃತ ಸ್ವಭಾವ ಮತ್ತು ನಡವಳಿಕೆಯ ಪ್ರವೃತ್ತಿಗಳನ್ನು ನಿರ್ಧರಿಸಲು ನಮ್ಮ ವ್ಯಕ್ತಿತ್ವ ತಜ್ಞರು ನಿಮ್ಮ ಜನ್ಮ ರೂಪಗಳನ್ನು ಅಧ್ಯಯನ ಮಾಡುತ್ತಿದ್ದಾರೆ.",
    "request_id": "ವಿಶ್ಲೇಷಣೆ ID",
    "status": "ಸ್ಥಿತಿ",
    "processing": "ಪ್ರಗತಿಯಲ್ಲಿದೆ",
    "pending": "ಸಾಲಿನಲ್ಲಿದೆ",
    "email_notification_sent": "ದೃಢೀಕರಣ ಇಮೇಲ್ ಕಳುಹಿಸಲಾಗಿದೆ",
    "whatsapp_update_coming": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ",
    "delivery_within_8_hours": "8 ಗಂಟೆಗಳೊಳಗೆ ವರದಿ ಸಿದ್ಧ",

    // Support & Contact
    "contact_support": "ಸ್ವಭಾವ ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ",
    "need_help": "ಮಾರ್ಗದರ್ಶನ ಬೇಕೇ?",
    "contact_us_at": "ನಮ್ಮನ್ನು ಇಲ್ಲಿ ಸಂಪರ್ಕಿಸಿ",

    // Error Messages
    "please_fill_all_required_fields": "ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಅಗತ್ಯವಾದ ವಿವರಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ",
    "payment_failed": "ಪಾವತಿ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "processing_failed": "ವಿಶ್ಲೇಷಣೆ ಪ್ರಕ್ರಿಯೆ ವಿಫಲವಾಗಿದೆ. ನಮ್ಮ ಬೆಂಬಲ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ.",

    // Nature-Specific Elements
    "elemental_composition": "ಮೂಲಭೂತ ಸಂಯೋಜನೆ",
    "dominant_element": "ಪ್ರಧಾನ ಮೂಲಧಾತು",
    "secondary_elements": "ದ್ವಿತೀಯ ಮೂಲಧಾತುಗಳು",
    "elemental_balance": "ಮೂಲಭೂತ ಸಮತೋಲನ",
    "natural_constitution": "ನೈಸರ್ಗಿಕ ಸಂವಿಧಾನ",
    "temperament_type": "ಸ್ವಭಾವ ಪ್ರಕಾರ",

    // Personality Traits
    "core_personality_traits": "ಮೂಲ ವ್ಯಕ್ತಿತ್ವ ಲಕ್ಷಣಗಳು",
    "surface_personality": "ಮೇಲ್ಮೈ ವ್ಯಕ್ತಿತ್ವ",
    "hidden_personality": "ಗುಪ್ತ ವ್ಯಕ್ತಿತ್ವ",
    "authentic_self": "ಅಧಿಕೃತ ಸ್ವಯಂ",
    "personality_layers": "ವ್ಯಕ್ತಿತ್ವ ಪದರಗಳು",
    "character_essence": "ಸ್ವರೂಪದ ಸಾರ",

    // Behavioral Patterns
    "natural_reactions": "ನೈಸರ್ಗಿಕ ಪ್ರತಿಕ್ರಿಯೆಗಳು",
    "instinctive_responses": "ಸಹಜ ಪ್ರತಿಕ್ರಿಯೆಗಳು",
    "behavioral_tendencies": "ನಡವಳಿಕೆಯ ಪ್ರವೃತ್ತಿಗಳು",
    "habitual_patterns": "ಅಭ್ಯಾಸದ ರೂಪಗಳು",
    "unconscious_behaviors": "ಅಪ್ರಜ್ಞಾಪೂರ್ವಕ ವರ್ತನೆಗಳು",
    "automatic_responses": "ಸ್ವಯಂಚಾಲಿತ ಪ್ರತಿಕ್ರಿಯೆಗಳು",

    // Strengths & Abilities
    "natural_strengths": "ನೈಸರ್ಗಿಕ ಶಕ್ತಿಗಳು",
    "inherent_abilities": "ಅಂತರ್ಗತ ಸಾಮರ್ಥ್ಯಗಳು",
    "inborn_talents": "ಜನ್ಮಜಾತ ಪ್ರತಿಭೆಗಳು",
    "natural_gifts": "ನೈಸರ್ಗಿಕ ಉಡುಗೊਰೆಗಳು",
    "core_competencies": "ಮೂಲ ಸಾಮರ್ಥ್ಯಗಳು",
    "instinctive_skills": "ಸಹಜ ಕೌಶಲ್ಯಗಳು",

    // Weaknesses & Challenges
    "natural_weaknesses": "ನೈಸರ್ಗಿಕ ದೌರ್ಬಲ್ಯಗಳು",
    "blind_spots": "ವ್ಯಕ್ತಿತ್ವದ ಅಂಧ ಕಲೆಗಳು",
    "growth_areas": "ಬೆಳವಣಿಗೆಯ ಕ್ಷೇತ್ರಗಳು",
    "challenging_traits": "ಸವಾಲಿನ ಲಕ್ಷಣಗಳು",
    "limiting_patterns": "ಸೀಮಿತಗೊಳಿಸುವ ರೂಪಗಳು",
    "shadow_aspects": "ನೆರಳಿನ ಅಂಶಗಳು",

    // Temperament Types
    "sanguine_nature": "ರಕ್ತಸಂಚಾರಿ ಸ್ವಭಾವ",
    "choleric_nature": "ಪಿತ್ತಪ್ರಧಾನ ಸ್ವಭಾವ",
    "melancholic_nature": "ವಿಷಾದಮಯ ಸ್ವಭಾವ",
    "phlegmatic_nature": "ಶ್ಲೇಷ್ಮಪ್ರಧಾನ ಸ್ವಭಾವ",
    "mixed_temperament": "ಮಿಶ್ರ ಮನೋಭಾವ",
    "temperament_blend": "ಮನೋಭಾವದ ಮಿಶ್ರಣ",

    // Elemental Natures
    "fire_personality": "ಅಗ್ನಿ ವ್ಯಕ್ತಿತ್ವ",
    "water_personality": "ನೀರಿನ ವ್ಯಕ್ತಿತ್ವ",
    "earth_personality": "ಭೂಮಿಯ ವ್ಯಕ್ತಿತ್ವ",
    "air_personality": "ವಾಯುವಿನ ವ್ಯಕ್ತಿತ್ವ",
    "space_personality": "ಆಕಾಶ ವ್ಯಕ್ತಿತ್ವ",
    "elemental_dominance": "ಮೂಲಭೂತ ಪ್ರಾಬಲ್ಯ",

    // Interaction Styles
    "social_nature": "ಸಾಮಾಜಿಕ ಸ್ವಭಾವ",
    "communication_style": "ಸಂವಹನ ಶೈಲಿ",
    "interaction_preferences": "ಸಂವಹನ ಆದ್ಯತೆಗಳು",
    "relationship_approach": "ಸಂಬಂಧದ ವಿಧಾನ",
    "conflict_style": "ಸಂಘರ್ಷ ಪರಿಹಾರ ಶೈಲಿ",
    "leadership_nature": "ನಾಯಕತ್ವದ ಸ್ವಭಾವ",

    // Emotional Nature
    "emotional_patterns": "ಭಾವನಾತ್ಮಕ ರೂಪಗಳು",
    "feeling_responses": "ಭಾವನೆಯ ಪ್ರತಿಕ್ರಿಯೆಗಳು",
    "emotional_expression": "ಭಾವನಾತ್ಮಕ ಅಭಿವ್ಯಕ್ತಿ",
    "mood_tendencies": "ಮೂಡ್ ಪ್ರವೃತ್ತಿಗಳು",
    "emotional_intelligence": "ಭಾವನಾತ್ಮಕ ಬುದ್ಧಿವಂತಿಕೆ",
    "sensitivity_levels": "ಸಂವೇದನಾ ಮಟ್ಟಗಳು",

    // Mental Nature
    "thinking_patterns": "ಚಿಂತನೆಯ ರೂಪಗಳು",
    "mental_approach": "ಮಾನಸಿಕ ವಿಧಾನ",
    "cognitive_style": "ಅರಿವಿನ ಶೈಲಿ",
    "learning_style": "ಕಲಿಕೆಯ ಶೈಲಿ",
    "decision_making": "ನಿರ್ಧಾರ ತೆಗೆದುಕೊಳ್ಳುವ ಶೈಲಿ",
    "problem_solving": "ಸಮಸ್ಯೆ ಪರಿಹಾರ ವಿಧಾನ",

    // Physical Nature
    "physical_constitution": "ಭೌತಿಕ ಸಂವಿಧಾನ",
    "energy_patterns": "ಶಕ್ತಿಯ ರೂಪಗಳು",
    "activity_preferences": "ಚಟುವಟಿಕೆಯ ಆದ್ಯತೆಗಳು",
    "physical_expressions": "ಭೌತಿಕ ಅಭಿವ್ಯಕ್ತಿಗಳು",
    "body_language": "ನೈಸರ್ಗಿಕ ದೇಹ ಭಾಷೆ",
    "physical_tendencies": "ಭೌತಿಕ ಪ್ರವೃತ್ತಿಗಳು",

    // Spiritual Nature
    "spiritual_inclinations": "ಆಧ್ಯಾತ್ಮಿಕ ಒಲವುಗಳು",
    "inner_nature": "ಆಂತರಿಕ ಸ್ವಭಾವ",
    "soul_expression": "ಆತ್ಮದ ಅಭಿವ್ಯಕ್ತಿ",
    "spiritual_path": "ನೈಸರ್ಗಿಕ ಆಧ್ಯಾತ್ಮಿಕ ಮಾರ್ಗ",
    "divine_connection": "ದೈವಿಕ ಸಂಪರ್ಕ ಶೈಲಿ",
    "transcendental_nature": "ಅತೀಂದ್ರಿಯ ಸ್ವಭಾವ",

    // Life Approach
    "life_philosophy": "ನೈಸರ್ಗಿಕ ಜೀವನ ತತ್ತ್ವಶಾಸ್ತ್ರ",
    "approach_to_challenges": "ಸವಾಲುಗಳಿಗೆ ವಿಧಾನ",
    "goal_orientation": "ಗುರಿ ದೃಷ್ಟಿಕೋನ",
    "success_definition": "ಯಶಸ್ಸಿನ ವ್ಯಾಖ್ಯಾನ",
    "life_priorities": "ಜೀವನದ ಆದ್ಯತೆಗಳು",
    "value_system": "ಮೂಲ ಮೌಲ್ಯ ವ್ಯವಸ್ಥೆ",

    // Career Nature
    "work_style": "ನೈಸರ್ಗಿಕ ಕೆಲಸದ ಶೈಲಿ",
    "career_preferences": "ವೃತ್ತಿ ಆದ್ಯತೆಗಳು",
    "professional_nature": "ವೃತ್ತಿಪರ ಸ್ವಭಾವ",
    "workplace_behavior": "ಕೆಲಸದ ಸ್ಥಳದ ನಡವಳಿಕೆ",
    "team_dynamics": "ತಂಡದ ಡೈನಾಮಿಕ್ಸ್",
    "professional_growth": "ವೃತ್ತಿಪರ ಬೆಳವಣಿಗೆಯ ರೂಪ",

    // Relationship Nature
    "relationship_style": "ಸಂಬಂಧದ ಶೈಲಿ",
    "love_expression": "ಪ್ರೀತಿಯ ಅಭಿವ್ಯಕ್ತಿ",
    "friendship_patterns": "ಸ್ನೇಹದ ರೂಪಗಳು",
    "family_dynamics": "ಕುಟುಂಬದ ಡೈನಾಮಿಕ್ಸ್",
    "partnership_nature": "ಪಾಲುದಾರಿಕೆಯ ಸ್ವಭಾವ",
    "social_connections": "ಸಾಮಾಜಿಕ ಸಂಪರ್ಕಗಳು",

    // Growth & Development
    "natural_evolution": "ನೈಸರ್ಗಿಕ ವಿಕಾಸ ಮಾರ್ಗ",
    "growth_potential": "ಬೆಳವಣಿಗೆಯ ಸಾಮರ್ಥ್ಯ",
    "development_areas": "ಅಭಿವೃದ್ಧಿ ಕ್ಷೇತ್ರಗಳು",
    "transformation_capacity": "ರೂಪಾಂತರ ಸಾಮರ್ಥ್ಯ",
    "learning_opportunities": "ಕಲಿಕೆಯ ಅವಕಾಶಗಳು",
    "self_improvement": "ಸ್ವಯಂ ಸುಧಾರಣೆ ಕ್ಷೇತ್ರಗಳು",

    // Seasonal Nature
    "seasonal_influences": "ಋತುಮಾನದ ಪ್ರಭಾವಗಳು",
    "cyclical_patterns": "ಚಕ್ರಾಕಾರ ರೂಪಗಳು",
    "natural_rhythms": "ನೈಸರ್ಗಿಕ ಲಯಗಳು",
    "biorhythms": "ವೈಯಕ್ತಿಕ ಜೈವಿಕ ಲಯಗಳು",
    "energy_cycles": "ಶಕ್ತಿ ಚಕ್ರಗಳು",
    "mood_cycles": "ಮೂಡ್ ಚಕ್ರಗಳು",

    // Environmental Nature
    "environmental_preferences": "ಪರಿಸರ ಆದ್ಯತೆಗಳು",
    "natural_habitat": "ನೈಸರ್ಗಿಕ ಆವಾಸಸ್ಥಾನ",
    "climate_preferences": "ಹವಾಮಾನ ಆದ್ಯತೆಗಳು",
    "space_requirements": "ಸ್ಥಳದ ಅಗತ್ಯತೆಗಳು",
    "comfort_zones": "ಆರಾಮ ವಲಯಗಳು",
    "optimal_environments": "ಸೂಕ್ತ ಪರಿಸರಗಳು",

    // Communication Nature
    "expression_style": "ಅಭಿವ್ಯಕ್ತಿ ಶೈಲಿ",
    "listening_style": "ಆಲಿಸುವ ಶೈಲಿ",
    "verbal_patterns": "ಮೌಖಿಕ ರೂಪಗಳು",
    "non_verbal_communication": "ಅಮೌಖಿಕ ಸಂವಹನ",
    "communication_barriers": "ಸಂವಹನ ಅಡೆತಡೆಗಳು",
    "effective_communication": "ಪರಿಣಾಮಕಾರಿ ಸಂವಹನ ಸಲಹೆಗಳು",

    // Stress & Relaxation
    "stress_patterns": "ಒತ್ತಡದ ರೂಪಗಳು",
    "stress_responses": "ಒತ್ತಡದ ಪ್ರತಿಕ್ರಿಯೆಗಳು",
    "relaxation_needs": "ವಿಶ್ರಾಂತಿ ಅಗತ್ಯತೆಗಳು",
    "recovery_methods": "ಚೇತರಿಕೆ ವಿಧಾನಗಳು",
    "self_care_nature": "ಸ್ವಯಂ ಆರೈಕೆ ಸ್ವಭಾವ",
    "wellness_approaches": "ಆರೋಗ್ಯ ವಿಧಾನಗಳು",

    // Creative Nature
    "creative_expression": "ಸೃಜನಾತ್ಮಕ ಅಭಿವ್ಯಕ್ತಿ",
    "artistic_inclinations": "ಕಲಾತ್ಮಕ ಒಲವುಗಳು",
    "innovation_style": "ನಾವೀನ್ಯತೆಯ ಶೈಲಿ",
    "creative_processes": "ಸೃಜನಾತ್ಮಕ ಪ್ರಕ್ರಿಯೆಗಳು",
    "inspiration_sources": "ಸ್ಫೂರ್ತಿ ಮೂಲಗಳು",
    "creative_blocks": "ಸೃಜನಾತ್ಮಕ ಅಡೆತಡೆಗಳು ಮತ್ತು ಪರಿಹಾರಗಳು"
};
